import api from '../lib/api';

const notificationService = {
    getVapidPublicKey: async () => {
        const response = await api.get('/push/public-key');
        return response.data.public_key;
    },

    savePushSubscription: async (subscription) => {
        const response = await api.post('/push-subscriptions', subscription);
        return response.data;
    },

    deletePushSubscription: async (endpoint) => {
        const response = await api.delete('/push-subscriptions', { data: { endpoint } });
        return response.data;
    },

    sendTestNotification: async () => {
        const response = await api.post('/push/test');
        return response.data;
    },

    getSubscribedCategoryIds: async () => {
        const response = await api.get('/category-subscriptions');
        return response.data.category_ids;
    },

    toggleCategorySubscription: async (categoryId) => {
        const response = await api.post(`/categories/${categoryId}/subscribe`);
        return response.data;
    }
};

export default notificationService;
